<template>
    <div>
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />

        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!integracao && !isUpdate && permissao.create) ||
                        (!integracao && isUpdate && permissao.update)
                    "
                    @click="saveChecks"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <!-- ativaniveltecnologico -->
                <div class="column is-3">
                    <label>
                        {{ $t('agro-niveltecnologico') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('agro-niveltecnologico') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(1)"
                            :type="checks.ativaniveltecnologico.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaniveltecnologico.habilita"
                            @click="changeCheckHabilita('ativaniveltecnologico')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(2)"
                            :type="checks.ativaniveltecnologico.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaniveltecnologico.obriga"
                            @click="changeCheckObriga('ativaniveltecnologico')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativacultivar -->
                <div class="column is-3">
                    <label>
                        {{ $t('cultivar') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="$t('plano-safra-tooltip-geral', { n: $t('cultivar') })"
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(3)"
                            :type="checks.ativacultivar.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativacultivar.habilita"
                            @click="changeCheckHabilita('ativacultivar')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(4)"
                            :type="checks.ativacultivar.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativacultivar.obriga"
                            @click="changeCheckObriga('ativacultivar')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativadatasemeadura -->
                <div class="column is-3">
                    <label>
                        {{ $t('data-semeadura') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('data-semeadura') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(5)"
                            :type="checks.ativadatasemeadura.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativadatasemeadura.habilita"
                            @click="changeCheckHabilita('ativadatasemeadura')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(6)"
                            :type="checks.ativadatasemeadura.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativadatasemeadura.obriga"
                            @click="changeCheckObriga('ativadatasemeadura')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaformulaadubacao -->
                <div class="column is-3">
                    <label>
                        {{ $t('formula-adubacao') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('formula-adubacao') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(10)"
                            :type="checks.ativaformulaadubacao.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaformulaadubacao.habilita"
                            @click="changeCheckHabilita('ativaformulaadubacao')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(11)"
                            :type="checks.ativaformulaadubacao.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaformulaadubacao.obriga"
                            @click="changeCheckObriga('ativaformulaadubacao')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaqtdeadubacao -->
                <div class="column is-3">
                    <label>
                        {{ $t('qtde-adubacao') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('qtde-adubacao') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(20)"
                            :type="checks.ativaqtdeadubacao.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaqtdeadubacao.habilita"
                            @click="changeCheckHabilita('ativaqtdeadubacao')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(21)"
                            :type="checks.ativaqtdeadubacao.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaqtdeadubacao.obriga"
                            @click="changeCheckObriga('ativaqtdeadubacao')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaplantasmetroquadrado -->
                <div class="column is-3">
                    <label>
                        {{ $t('plantas-metro-quadrado') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('plantas-metro-quadrado') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(30)"
                            :type="checks.ativaplantasmetroquadrado.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaplantasmetroquadrado.habilita"
                            @click="changeCheckHabilita('ativaplantasmetroquadrado')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(31)"
                            :type="checks.ativaplantasmetroquadrado.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaplantasmetroquadrado.obriga"
                            @click="changeCheckObriga('ativaplantasmetroquadrado')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaprevisaoproducao -->
                <div class="column is-3">
                    <label>
                        {{ $t('previsao-producao') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('previsao-producao') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(40)"
                            :type="checks.ativaprevisaoproducao.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaprevisaoproducao.habilita"
                            @click="changeCheckHabilita('ativaprevisaoproducao')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(41)"
                            :type="checks.ativaprevisaoproducao.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaprevisaoproducao.obriga"
                            @click="changeCheckObriga('ativaprevisaoproducao')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativacolunaespaco -->
                <div class="column is-3">
                    <label>
                        {{ $t('coluna-espaco') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('coluna-espaco') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(60)"
                            :type="checks.ativacolunaespaco.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativacolunaespaco.habilita"
                            @click="changeCheckHabilita('ativacolunaespaco')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(61)"
                            :type="checks.ativacolunaespaco.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativacolunaespaco.obriga"
                            @click="changeCheckObriga('ativacolunaespaco')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativalinhaespaco -->
                <div class="column is-3">
                    <label>
                        {{ $t('linha-espaco') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('linha-espaco') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(70)"
                            :type="checks.ativalinhaespaco.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativalinhaespaco.habilita"
                            @click="changeCheckHabilita('ativalinhaespaco')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(71)"
                            :type="checks.ativalinhaespaco.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativalinhaespaco.obriga"
                            @click="changeCheckObriga('ativalinhaespaco')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaareatotalplantio -->
                <div class="column is-3">
                    <label>
                        {{ $t('area-total-plantio') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('area-total-plantio') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(70)"
                            :type="checks.ativaareatotalplantio.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaareatotalplantio.habilita"
                            @click="changeCheckHabilita('ativaareatotalplantio')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(71)"
                            :type="checks.ativaareatotalplantio.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaareatotalplantio.obriga"
                            @click="changeCheckObriga('ativaareatotalplantio')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativadatacolheita -->
                <div class="column is-3">
                    <label>
                        {{ $t('data-colheita') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('data-colheita') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(70)"
                            :type="checks.ativadatacolheita.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativadatacolheita.habilita"
                            @click="changeCheckHabilita('ativadatacolheita')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(71)"
                            :type="checks.ativadatacolheita.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativadatacolheita.obriga"
                            @click="changeCheckObriga('ativadatacolheita')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
                <!-- ativaprodutividadeobtida -->
                <div class="column is-3">
                    <label>
                        {{ $t('produtividade-obtida') }}
                        <b-icon
                            icon="information"
                            size="is-small"
                            v-tippy
                            :title="
                                $t('plano-safra-tooltip-geral', { n: $t('produtividade-obtida') })
                            "
                        />
                    </label>
                    <div class="group-buttons">
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(70)"
                            :type="checks.ativaprodutividadeobtida.habilita ? 'is-primary' : ''"
                            :outlined="!checks.ativaprodutividadeobtida.habilita"
                            @click="changeCheckHabilita('ativaprodutividadeobtida')"
                        >
                            <span>{{ $t('habilita') }}</span>
                        </b-button>
                        <b-button
                            class="expanded-buttons"
                            :id="generateId(71)"
                            :type="checks.ativaprodutividadeobtida.obriga ? 'is-primary' : ''"
                            :outlined="!checks.ativaprodutividadeobtida.obriga"
                            @click="changeCheckObriga('ativaprodutividadeobtida')"
                        >
                            <span>{{ $t('obriga') }}</span>
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TipoCulturaService from '@/services/agro/CulturaService';
import Message from '@/models/Message';

export default {
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('TIPOCULTURA'),
            service: new TipoCulturaService(this.$http, this.$router),
            tipocultura: {
                idtipocultura: null,
                ativacultivar: null,
                ativaniveltecnologico: null,
                ativadatasemeadura: null,
                ativaqtdeadubacao: null,
                ativaformulaadubacao: null,
                ativalinhaespaco: null,
                ativaprevisaoproducao: null,
                ativacolunaespaco: null,
                ativaplantasmetroquadrado: null,
                ativaareatotalplantio: null,
                ativadatacolheita: null,
                ativaprodutividadeobtida: null,
            },
            msgs: [],
            isLoading: false,
            isSaving: false,
            permissao: false,
            cantEdit: false,
            // para controlar algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,

            checks: {
                ativacultivar: { habilita: false, obriga: false },
                ativaniveltecnologico: { habilita: false, obriga: false },
                ativadatasemeadura: { habilita: false, obriga: false },
                ativaqtdeadubacao: { habilita: false, obriga: false },
                ativaformulaadubacao: { habilita: false, obriga: false },
                ativacolunaespaco: { habilita: false, obriga: false },
                ativaprevisaoproducao: { habilita: false, obriga: false },
                ativalinhaespaco: { habilita: false, obriga: false },
                ativaplantasmetroquadrado: { habilita: false, obriga: false },
                ativaareatotalplantio: { habilita: false, obriga: false },
                ativadatacolheita: { habilita: false, obriga: false },
                ativaprodutividadeobtida: { habilita: false, obriga: false },
            },
            tabela: {
                idtabela: null,
                idtabelaerp: null,
            },
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    watch: {
        tabela: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChanged', true);
                }
            },
        },
    },
    created() {
        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.isAgro) {
            (this.abrev = this.$route.meta.contexto.slice(0, 4)),
                (this.permissao = this.hasPermissionAccess(
                    'agro',
                    'agro-cadastros',
                    'agro-cultura'
                ));
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
        }

        if ((!this.isUpdate && !this.permissao.create) || (this.isUpdate && !this.permissao.read)) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-cultura` },
            });
        } else {
            if (this.isUpdate) {
                this.cantEdit = !this.permissao.update;
                this.carregarDados();
            }
        }
    },
    methods: {
        setChecksToSave(obj) {
            if (obj.obriga) {
                return 2;
            } else if (obj.habilita) {
                return 1;
            } else {
                return 0;
            }
        },
        changeCheckHabilita(v) {
            this.checks[v].habilita = !this.checks[v].habilita;
            if (!this.checks[v].habilita) this.checks[v].obriga = false;
        },
        changeCheckObriga(v) {
            this.checks[v].obriga = !this.checks[v].obriga;
            if (this.checks[v].obriga) this.checks[v].habilita = true;
        },
        mapChecksToSave(v) {
            if (!this.checks[v].habilita) {
                return 0;
            } else if (this.checks[v].habilita && !this.checks[v].obriga) {
                return 1;
            } else if (this.checks[v].obriga) {
                return 2;
            } else {
                console.log('Valor inválido!');
            }
        },
        generateId(numberId) {
            return this.$route.name + '-plano-safra-' + numberId;
        },

        mapChecksObriga(v) {
            return v == 2;
        },

        mapChecksHabilita(v) {
            return v == 1 || v == 2;
        },

        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.tipocultura.idtipocultura = this.$route.params.id;
            this.service
                .find(this.$route.params.id, this.abrev)
                .then((body) => {
                    let res = body.content;
                    this.tipocultura.ativacultivar = res.ativacultivar;
                    this.tipocultura.ativaniveltecnologico = res.ativaniveltecnologico;
                    this.tipocultura.ativadatasemeadura = res.ativadatasemeadura;
                    this.tipocultura.ativaqtdeadubacao = res.ativaqtdeadubacao;
                    this.tipocultura.ativaformulaadubacao = res.ativaformulaadubacao;
                    this.tipocultura.ativalinhaespaco = res.ativalinhaespaco;
                    this.tipocultura.ativaprevisaoproducao = res.ativaprevisaoproducao;
                    this.tipocultura.ativacolunaespaco = res.ativacolunaespaco;
                    this.tipocultura.ativaplantasmetroquadrado = res.ativaplantasmetroquadrado;
                    this.tipocultura.ativaareatotalplantio = res.ativaareatotalplantio;
                    this.tipocultura.ativadatacolheita = res.ativadatacolheita;
                    this.tipocultura.ativaprodutividadeobtida = res.ativaprodutividadeobtida;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.checks.ativacultivar.obriga = this.mapChecksObriga(
                        this.tipocultura.ativacultivar
                    );
                    this.checks.ativaniveltecnologico.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaniveltecnologico
                    );
                    this.checks.ativadatasemeadura.obriga = this.mapChecksObriga(
                        this.tipocultura.ativadatasemeadura
                    );
                    this.checks.ativaqtdeadubacao.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaqtdeadubacao
                    );
                    this.checks.ativaformulaadubacao.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaformulaadubacao
                    );
                    this.checks.ativacolunaespaco.obriga = this.mapChecksObriga(
                        this.tipocultura.ativacolunaespaco
                    );
                    this.checks.ativaprevisaoproducao.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaprevisaoproducao
                    );
                    this.checks.ativalinhaespaco.obriga = this.mapChecksObriga(
                        this.tipocultura.ativalinhaespaco
                    );
                    this.checks.ativaplantasmetroquadrado.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaplantasmetroquadrado
                    );
                    this.checks.ativaareatotalplantio.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaareatotalplantio
                    );
                    this.checks.ativadatacolheita.obriga = this.mapChecksObriga(
                        this.tipocultura.ativadatacolheita
                    );
                    this.checks.ativaprodutividadeobtida.obriga = this.mapChecksObriga(
                        this.tipocultura.ativaprodutividadeobtida
                    );

                    this.checks.ativacultivar.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativacultivar
                    );
                    this.checks.ativaniveltecnologico.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaniveltecnologico
                    );
                    this.checks.ativadatasemeadura.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativadatasemeadura
                    );
                    this.checks.ativaqtdeadubacao.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaqtdeadubacao
                    );
                    this.checks.ativaformulaadubacao.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaformulaadubacao
                    );
                    this.checks.ativacolunaespaco.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativacolunaespaco
                    );
                    this.checks.ativaprevisaoproducao.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaprevisaoproducao
                    );
                    this.checks.ativalinhaespaco.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativalinhaespaco
                    );
                    this.checks.ativaplantasmetroquadrado.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaplantasmetroquadrado
                    );
                    this.checks.ativaareatotalplantio.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaareatotalplantio
                    );
                    this.checks.ativadatacolheita.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativadatacolheita
                    );
                    this.checks.ativaprodutividadeobtida.habilita = this.mapChecksHabilita(
                        this.tipocultura.ativaprodutividadeobtida
                    );
                    setTimeout(() => {
                        this.$emit('isChanged', false);
                    }, 300);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        saveChecks() {
            this.isLoading = true;
            let tempTipoCultura = Object.assign({}, this.tipocultura);
            tempTipoCultura = this.mapTosave(tempTipoCultura);
            tempTipoCultura.ativacultivar = this.setChecksToSave(this.checks.ativacultivar);
            tempTipoCultura.ativaniveltecnologico = this.setChecksToSave(
                this.checks.ativaniveltecnologico
            );
            tempTipoCultura.ativadatasemeadura = this.setChecksToSave(
                this.checks.ativadatasemeadura
            );
            tempTipoCultura.ativaqtdeadubacao = this.setChecksToSave(this.checks.ativaqtdeadubacao);
            tempTipoCultura.ativaformulaadubacao = this.setChecksToSave(
                this.checks.ativaformulaadubacao
            );
            tempTipoCultura.ativalinhaespaco = this.setChecksToSave(this.checks.ativalinhaespaco);
            tempTipoCultura.ativaprevisaoproducao = this.setChecksToSave(
                this.checks.ativaprevisaoproducao
            );
            tempTipoCultura.ativacolunaespaco = this.setChecksToSave(this.checks.ativacolunaespaco);
            tempTipoCultura.ativaplantasmetroquadrado = this.setChecksToSave(
                this.checks.ativaplantasmetroquadrado
            );
            tempTipoCultura.ativaareatotalplantio = this.setChecksToSave(
                this.checks.ativaareatotalplantio
            );
            tempTipoCultura.ativadatacolheita = this.setChecksToSave(this.checks.ativadatacolheita);
            tempTipoCultura.ativaprodutividadeobtida = this.setChecksToSave(
                this.checks.ativaprodutividadeobtida
            );

            this.isSaving = true;
            this.service
                .saveChecks(tempTipoCultura, this.abrev)
                .then((value) => {
                    if (value.message == null) {
                        let msg = 'msg-tipocultura-edita';
                        this.msgs.push(new Message('success', msg, true));
                        this.$emit('isChanged', false);
                    } else {
                        if (this.$t(body.message)) {
                            this.msgs.push(new Message('alert', body.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    if (e.body.status == 409) {
                        this.msgs.push(new Message('alert', e.body.message, true));
                    } else {
                        console.error('Erro ao salvar: ' + e);
                        this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                    }
                })
                .finally(() => {
                    this.isSaving = false;
                    this.isLoading = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
